module.exports = __webpack_public_path__ + "img/step-4.1e99ea1a.png";